<template>
  <v-row>
    <v-col cols="12" sm="6">
      <h6>{{ $t("info_card.name_en") }}</h6>
      <v-text-field
        density="compact"
        v-model="nameEN"
        :rules="rules"
        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 ) || (event.charCode == 45) || (event.charCode == 39) || (event.charCode == 46) || (event.charCode == 32)"
        @paste.prevent
        @update:model-value="
          (v) => {
            nameEN = v.toUpperCase();
          }
        "
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <h6>{{ $t("info_card.surname_en") }}</h6>
      <v-text-field
        density="compact"
        v-model="surnameEN"
        :rules="rules"
        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 ) || (event.charCode == 45) || (event.charCode == 39) || (event.charCode == 46) || (event.charCode == 32)"
        @paste.prevent
        @update:model-value="
          (v) => {
            surnameEN = v.toUpperCase();
          }
        "
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "nameENCard",
  props: {
    modelValue: Object,
  },
  data: () => ({
    rules: [validator.required],
    // nameEN: null,
    // surnameEN: null,
  }),

  computed: {
    nameEN: {
      get() {
        return this.modelValue.nameEN;
      },
      set(value) {
        this.$emit("update:modelValue", {
          nameEN: value,
          surnameEN: this.surnameEN,
        });
      },
    },

    surnameEN: {
      get() {
        return this.modelValue.surnameEN;
      },
      set(value) {
        this.$emit("update:modelValue", {
          nameEN: this.nameEN,
          surnameEN: value,
        });
      },
    },
  },

  // watch: {
  //   nameEN() {
  //     this.$emit("update:modelValue", {
  //       nameEN: this.nameEN,
  //       surnameEN: this.surnameEN,
  //     });
  //   },
  //   surnameEN() {
  //     this.$emit("update:modelValue", {
  //       nameEN: this.nameEN,
  //       surnameEN: this.surnameEN,
  //     });
  //   },
  // },
};
</script>
